<template>
  <div>
    <v-container fluid class="pb-0">
      <v-sheet elevation="1" class="header-bar">
        <v-layout row class="align-center" wrap>
          <v-flex xs12 lg6>
            <v-text-field
              label="Recherche..."
              append-icon="search"
              v-model="search"
            ></v-text-field>
          </v-flex>
          <v-flex
            xs12
            lg6
            class="d-inline-flex justify-end d-flex-initial align-center"
          >
            <v-select
              :items="[2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025]"
              v-model="year"
              :style="{ width: '100px' }"
              class="mr-2"
            ></v-select>
            <v-btn-toggle
              v-model="filter"
              mandatory
              style="box-shadow: none"
              v-if="$mq === 'lg'"
            >
              <v-btn
                flat
                v-for="s in allStatus"
                :key="s.value"
                :value="s.value"
              >
                {{ s.text }}
              </v-btn>
            </v-btn-toggle>
            <v-select
              v-else
              style="width: 100%"
              label="État"
              :items="allStatus"
              v-model="filter"
            />
          </v-flex>
          <v-flex xs12 v-if="$mq === 'sm'">
            <v-select
              style="width: 100%"
              label="Colonne"
              :items="allColumns"
              v-model="column"
            />
          </v-flex>
        </v-layout>
      </v-sheet>
    </v-container>
  </div>
</template>

<script>
import { ALL_COLUMNS } from "../data/DefaultSettings";
import { mapGetters, mapState, mapMutations } from "vuex";
import { debounce } from "lodash";

export default {
  name: "ProjectsFilter",
  computed: {
    ...mapState("projects", ["filters", "columns"]),
    ...mapGetters("user", ["isSuperAdmin", "isAdmin"]),

    search: {
      get() {
        return this.filters.search;
      },
      set(value) {
        this.debounceSetFilterSearch(value);
      }
    },

    year: {
      get() {
        return this.filters.year;
      },
      set(value) {
        this.setFilterYear(value);
        this.$emit("update");
      }
    },

    filter: {
      get() {
        return this.filters.filter;
      },
      set(value) {
        this.setFilterFilter(value);
        this.$emit("update");
      }
    },

    column: {
      get() {
        return this.filters.column;
      },
      set(value) {
        this.setFilterColumn(value);
      }
    },

    allStatus() {
      return [
        { text: "Actifs", value: "active" },
        { text: "Alertes", value: "alerts" },
        { text: "Abandonnés", value: "stopped" },
        { text: "Tous", value: "all" }
      ];
    },
    allColumns() {
      const availableColumns = ALL_COLUMNS.filter(
        col => col.value === "all" || this.columns.includes(col.value)
      );
      if (this.isSuperAdmin) {
        return availableColumns;
      } else if (this.isAdmin) {
        return availableColumns.filter(({ superAdminOnly }) => !superAdminOnly);
      } else {
        return availableColumns.filter(
          ({ superAdminOnly, adminOnly }) => !superAdminOnly && !adminOnly
        );
      }
    }
  },
  methods: {
    ...mapMutations("projects", [
      "setFilterSearch",
      "setFilterFilter",
      "setFilterColumn",
      "setFilterYear"
    ]),

    debounceSetFilterSearch: debounce(
      function(value) {
        this.setFilterSearch(value);
      },
      300,
      { maxWait: 8e3 }
    )
  }
};
</script>
